export const getDownloadLinks = async (client, username, email) => {
  try {
    return await client.post('/downloadlinks', {}, { username, email });
  } catch (err) {
    console.warn(err);
    throw err;
  }
};
